<h2>{{ headline }}</h2>
@if (isLoadingPlatformItems) {
  <p-skeleton width="100%" height="10rem" />
} @else {
  @if (propertyWithMortgageSelectItems?.length) {
    <ng-container [formGroup]="stepFormGroup">
      <label>Select property</label>
      <shared-property-mortgage-select
        #propertyMortgageSelect
        class="property-mortgage-select"
        [formControl]="stepFormGroup.controls.propertyMortgageSelectItem"
        [propertyMortgageSelectItems]="propertyWithMortgageSelectItems"
        [inline]="true" />
    </ng-container>
  } @else {
    Looks like you don't have a property with mortgage.
  }
}
@if (isSkipPropertySelectPossible) {
  <cp-inline-redirect-link
    (click)="skipPropertySelection()"
    class="margin-top-auto"
    label="It is not connected to any of my current properties or mortgages" />
}
<cp-stepper
  class="stepper"
  [forwardButtonEnabled]="stepFormGroup.valid"
  [hideProgressBar]="true"
  [showForwardButtonIcon]="false"
  [hideBackButton]="!isBackButtonVisible"
  [showSkipButton]="false"
  (forward)="emitNextClicked()"
  (back)="emitBackClicked()" />
